// extracted by mini-css-extract-plugin
export default {"headerText":"_2b9LKRGmvi-s8i9spQKgys","text":"_1ahjUDlsja6Yo0JcBC1ElA"};